import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, Button, Typography, Box } from "@mui/material";
import { registerTokenExpiredHandler, clearTokenExpiredHandler } from "./tokenExpiry";

const TokenExpiredDialog = ({ open, onClose }) => {
    const navigate = useNavigate();

    const handleLogin = () => {
        onClose();
        navigate("/login");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{
            sx: {
                borderRadius: '16px'
            }
        }}>
            <DialogContent>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "16px"
                    }}
                >
                    <Typography
                        id="token-expire-modal-description"
                        sx={{
                            mb: 2,
                            textAlign: "center",
                            color: "#555",
                            fontWeight: "bold",
                        }}
                    >
                        Your login session has expired. Please log in again.
                    </Typography>

                    <Button onClick={handleLogin} variant="contained" sx={{ textTransform: "none" }}>Log In</Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

const GlobalDialogProvider = ({ children }) => {
    const [tokenExpiredOpen, setTokenExpiredOpen] = useState(false);

    const showTokenExpiredDialog = useCallback(() => {
        setTokenExpiredOpen(true);
    }, []);

    useEffect(() => {
        registerTokenExpiredHandler(showTokenExpiredDialog);
        return () => clearTokenExpiredHandler();
    }, [showTokenExpiredDialog]);

    return (
        <>
            {children}
            <TokenExpiredDialog open={tokenExpiredOpen} onClose={() => setTokenExpiredOpen(false)} />
        </>
    );
};

export default GlobalDialogProvider;
